import { PaymentAvailabilityEnum } from '.spec/self-care/tsTypes';

import { QueryFilter } from '@skippay/core/utils/apiUtils';
import { insertSelectionSet } from '@skippay/core/utils/gqlAstUtils';

import MyContractApplicationsQuery from 'queries/MyContractApplicationsQuery.graphql';
import MyContractBillingQuery from 'queries/MyContractBillingQuery.graphql';
import MyContractTransactionsQuery from 'queries/MyContractTransactionsQuery.graphql';
import MyContractTransactionWithReceiptQuery from 'queries/MyContractTransactionWithReceiptQuery.graphql';
import { getVirtualApplicationStatus } from 'utils/applicationUtils';

const resolvers = {
	Application: {
		billing(application, _args, context, info) {
			return (
				application.originBillingId &&
				context.client
					.query({
						query: insertSelectionSet(MyContractBillingQuery, info),
						variables: {
							billingId: application.originBillingId,
						},
					})
					.then(({ data: { myContractBilling } }) => myContractBilling)
			);
		},
		isPayable(application) {
			return (
				application.financing?.paymentAvailability?.availability ===
				PaymentAvailabilityEnum.AVAILABLE
			);
		},
		transaction(application, _args, context, info) {
			return (
				application.billingTransactionItemId &&
				context.client
					.query({
						query: insertSelectionSet(MyContractTransactionWithReceiptQuery, info),
						variables: {
							id: application.billingTransactionItemId,
						},
					})
					.then(({ data: { myContractTransaction } }) => myContractTransaction)
			);
		},
		virtualApplicationStatus(application) {
			return getVirtualApplicationStatus(application);
		},
	},
	Billing: {
		billingApplications(billing, args, context, info) {
			const billingIdFilter = new QueryFilter().prop('originBillingId').eq(billing.id);
			return context.client
				.query({
					query: insertSelectionSet(MyContractApplicationsQuery, info),
					variables: {
						...args,
						filter: String(args?.filter ? billingIdFilter.merge(args.filter) : billingIdFilter),
					},
				})
				.then(({ data: { myContractApplications } }) => myContractApplications);
		},
		billingTransactions(billing, args, context, info) {
			const billingIdFilter = new QueryFilter().prop('billingId').eq(billing.id);
			return context.client
				.query({
					query: insertSelectionSet(MyContractTransactionsQuery, info),
					variables: {
						...args,
						filter: String(args.filter ? billingIdFilter.merge(args.filter) : billingIdFilter),
					},
				})
				.then(({ data: { myContractTransactions } }) => myContractTransactions);
		},
	},
	Document: {
		id(document) {
			return `${document.type}:${document.file.createdDate}`;
		},
	},
	RevolvingTransaction: {
		billing(revolvingTransaction, args, context, info) {
			return context.client
				.query({
					query: insertSelectionSet(MyContractBillingQuery, info),
					variables: {
						billingId: revolvingTransaction.billingId,
					},
				})
				.then(({ data: { myContractBilling } }) => myContractBilling);
		},
		deferredBilling(revolvingTransaction, args, context, info) {
			return !revolvingTransaction.additionalInfoDeferredBilling
				? null
				: context.client
						.query({
							query: insertSelectionSet(MyContractBillingQuery, info),
							variables: {
								billingId: revolvingTransaction.additionalInfoDeferredBilling.id,
							},
						})
						.then(({ data: { myContractBilling } }) => myContractBilling);
		},
	},
	InvestmentTransaction_bucket: {
		microInvestmentTransactions(bucket, args, context, info) {
			const bucketTransactionsFilter = new QueryFilter().prop('bucketId').eq(bucket.id);
			return context.client
				.query({
					query: insertSelectionSet(MyContractTransactionsQuery, info),
					variables: {
						...args,
						filter: String(
							args?.filter ? bucketTransactionsFilter.merge(args.filter) : bucketTransactionsFilter
						),
					},
				})
				.then(({ data: { myContractTransactions } }) => myContractTransactions);
		},
	},
};

export default resolvers;
